import React from 'react';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';

const RecordPaymentSuccess = ({closeModal}:any) => {
  return (
    <>
    <div className='h-screen max-w-lg'>
    <h1 className="text-[25px] font-bold text-center mt-[87px]">You've recorded a payment</h1>
      <div className="flex justify-center mt-[61px]">
        <ProcessSuccessful />
      </div>
      <button
        className="w-[215px] h-[48px] mt-[4em] ml-[3em] rounded-md text-[#FFFFFF] border border-[#044E97] text-[16px] font-medium bg-[#044E97]"
          onClick={closeModal}
        >
        Back To View Invoice
        </button>
    </div>
     
    </>
  );
};

export default RecordPaymentSuccess;
